import { render, staticRenderFns } from "./AutomaticBackupsModal.vue?vue&type=template&id=7ec48c99&scoped=true"
import script from "./AutomaticBackupsModal.vue?vue&type=script&lang=js"
export * from "./AutomaticBackupsModal.vue?vue&type=script&lang=js"
import style0 from "./AutomaticBackupsModal.vue?vue&type=style&index=0&id=7ec48c99&prod&lang=scss"
import style1 from "./AutomaticBackupsModal.vue?vue&type=style&index=1&id=7ec48c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec48c99",
  null
  
)

export default component.exports